 
export const SEARCH_QUERIES = "SEARCH_QUERIES";

// eslint-disable-next-line import/no-anonymous-default-export
export default { 
  SEARCH_QUERIES
}
